import { render, staticRenderFns } from "./MainGraphCard.vue?vue&type=template&id=00272f34&scoped=true&"
import script from "./MainGraphCard.vue?vue&type=script&lang=js&"
export * from "./MainGraphCard.vue?vue&type=script&lang=js&"
import style0 from "./MainGraphCard.vue?vue&type=style&index=0&id=00272f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00272f34",
  null
  
)

export default component.exports